import { Accordion } from 'melt/builders';

import AiAssistantCard from './AiAssistantCard.svelte';
import AssistantDoneCard from './AssistantDoneCard.svelte';
import AssistantHeader from './AssistantHeader.svelte';
import AssistantPanel from './AssistantPanel.svelte';

export const Assistant = {
  Header: AssistantHeader,
  Panel: AssistantPanel,
  AiCard: AiAssistantCard,
  DoneCard: AssistantDoneCard,
};

export function createAssistantAccordion(onCardChange?: (cardId: string | undefined) => void) {
  const accordion = new Accordion<false>({
    multiple: false,
    onValueChange: onCardChange,
  });
  return accordion;
}
